import React from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

const LoaderModal = () => {
  const isLoading = useSelector((state) => state?.auth?.loading);
  return (
    isLoading && (
      <motion.div
        className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="flex flex-col items-center">
          <div
            className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"
            role="status"
          ></div>
          <span className="mt-4 text-white text-lg font-semibold">
            Loading...
          </span>
        </div>
      </motion.div>
    )
  );
};

export default LoaderModal;

// Usage example:
// import React, { useState } from "react";
// import LoaderModal from "./LoaderModal";

// const App = () => {
//   const [isLoading, setIsLoading] = useState(false);

//   return (
//     <div>
//       <button
//         onClick={() => setIsLoading(true)}
//         className="bg-blue-500 text-white px-4 py-2 rounded"
//       >
//         Show Loader
//       </button>
//       <button
//         onClick={() => setIsLoading(false)}
//         className="bg-red-500 text-white px-4 py-2 rounded ml-2"
//       >
//         Hide Loader
//       </button>
//       <LoaderModal isLoading={isLoading} />
//     </div>
//   );
// };

// export default App;
